<template>
  <div>
    <div class="top-breadcrumb">
      <ol class="breadcrumb" style="background-color: white">
        <li class="breadcrumb-item" style="margin-left: 15px">
          <router-link to="" style="color: #8cc63f !important">
            Portfolio Management
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            style="color: #8cc63f !important"
            :to="'/' + authUser.userable_type + '/plans'"
            >Plans</router-link
          >
        </li>
      </ol>
    </div>
    <div style="display: flex; justify-content: space-around" class="col-12">
      <span
        class="col-1"
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          color: gray;
        "
      >
        <i
          class="fa fa-filter"
          style="font-size: 15px; color: #8cc63f; margin-right: 5px"
        ></i>
        Filter
      </span>
      <span class="col-5">
        <input
          type="text"
          class="form-control"
          placeholder="Keyword"
          style="padding: 10px"
        />
      </span>
    </div>
    <div style="display: flex; justify-content: center; margin-top: 50px">
      <div
        style="display: flex; justify-content: center; cursor: pointer"
        @click="redirectToCreatePlan()"
      >
        <div>
          <i
            class="fa fa-plus-circle"
            style="font-size: 90px; color: #8cc63f; margin-right: 5px"
          ></i>
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            flex-direction: column;
            margin: 0;
            justify-content: center;
            margin-left: 10px;
          "
        >
          <p
            style="
              margin: 0px;
              font-size: 40px;
              margin-bottom: 5px;
              color: #8cc63f;
            "
          >
            ADD
          </p>
          <p style="margin: 0; color: #8cc63f; font-size: 14px">new plan</p>
        </div>
      </div>
    </div>
    <spinner v-if="searchingPlans" />
    <pagination
      v-else
      @viewPlan="redirectToPlan"
      style="padding: 0 50px"
      :data="plansPaginated"
      scope="props"
      itemTemplate="plan"
      :classes="['planClass', 'col-12']"
    >
    </pagination>
  </div>
</template>
<script>
import PlansFilter from "../../filters/PlansFilter";
import sweetAlert from "sweetalert2";
import { mapState } from "vuex";
import Pagination from "../common/Pagination.vue";
import Spinner from "vue-simple-spinner";

export default {
  name: "plans",
  data() {
    return {
      selectedPlanId: null,
      actionModalType: null,
      showPlanModal: false,
      columns: [],
    };
  },
  components: {
    
    Pagination,
    Spinner,
  },
  created: function () {
    if (this.plansPaginated == null || !this.plansPaginated.length) {
      var plansFilter = PlansFilter();
      this.$store
        .dispatch("searchPlans", {
          filter: plansFilter,
          resultMode: "paginated",
        })
        .then(() => {
          this.filterPlans();
        });
    }
  },
  computed: {
    ...mapState({
      authUser: (state) => state.userStore.authUser,
      plansPaginated: (state) => state.planStore.planSearch.plansPaginated,
      searchingPlans: (state) => state.planStore.planSearch.searchingPlans,
    }),
  },
  methods: {
    init() {
      this.selectedPlanId = null;
      this.actionModalType = null;
      this.showPlanModal = false;
      this.$store.dispatch("searchPlan").then(() => {
        this.filterPlans();
      });
    },
    filterPlans() {},
    handleSave(plan) {
      if (this.actionModalType == "createModal") {
        this.createPlan(plan);
      } else {
        this.updatePlan(plan);
      }
    },
    redirectToCreatePlan() {
      this.$router.push("/" + this.authUser.userable_type + "/plans/create");
    },
    redirectToPlan(plan) {
      this.$router.push(
        "/" + this.authUser.userable_type + "/plan/" + plan.name + "/" + plan.id
      );
    },
    createPlan(plan) {
      this.$store.dispatch("createPlan", plan);
    },
    updatePlan(plan) {
      this.$store.dispatch("updatePlan", plan);
    },
    deletePlan(id) {
      sweetAlert({
        title: "Confirmation",
        text: "Are you sure you want to delete this plan?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if(result.value) {
          this.$store.dispatch("deletePlan", id);
        }
      });
    },
    toggleCreatePlanModal() {
      this.showPlanModal = !this.showPlanModal;
      this.showPlanModal ? (this.actionModalType = "createModal") : null;
    },
    toggleUpdatePlanModal(id = null) {
      this.showPlanModal = !this.showPlanModal;
      if (this.showPlanModal) {
        this.actionModalType = "updateModal";
        this.selectedPlanId = id;
      } else {
        this.actionModalType = null;
        this.selectedPlanId = null;
      }
    },
  },
};
</script> 
 <style>
.md-ripple {
  padding: 0px !important;
}
.table.vgt-table {
  font-size: 20px;
}
.planClass {
  display: flex;
  flex-flow: wrap;
  justify-content: space-around;
}
</style>


// WEBPACK FOOTER //
// resources/js/pages/admin/plans.vue